// extracted by mini-css-extract-plugin
module.exports =  {"optional":"Oc87twU"};